import { AccountActivityAPI } from 'api'

export const fetchMissedAccountsReport = (orgId: number) => {
  return AccountActivityAPI.get(`/v2/activity_report/missed_accounts/org/${orgId}`).then(res => res.data)
}
